export type LayoutMode = "workstation" | "compact" | "mobile" | "phone";

/** Layout thresholds from docs/DESK_GAME_DESIGN.md §8. */
export function layoutModeForWidth(width: number): LayoutMode {
  if (width >= 1200) return "workstation";
  if (width >= 768) return "compact";
  if (width >= 430) return "mobile";
  return "phone";
}

export function isTouchEditor(mode: LayoutMode): boolean {
  return mode === "mobile" || mode === "phone";
}
